import type { App } from 'vue';
import * as CookieConsent from 'vanilla-cookieconsent';

import { adaptV3PreferencesToStorage } from '@/helper/cookie-consent/application';
import { saveConsentToStorage } from '@/helper/cookie-consent/storage';
import { isConsentPreferences } from '@/helper/cookie-consent/validation';
import type { CookieConsentInstance } from '@/shims-vue';

import baseConfig from '@/cookie-config';

function createConsentCallbacks() {
  return {
    onConsent: () => {
      const prefs = CookieConsent.getUserPreferences();
      if (!prefs) return;
      const adapted = adaptV3PreferencesToStorage(prefs);
      if (!isConsentPreferences(adapted)) {
        console.error('[CookieConsent] Invalid preferences from v3', prefs);
        return;
      }
      window._matomoOkay =
        prefs.acceptedCategories?.includes('analytical') ?? false;
      saveConsentToStorage(adapted);
      window.dispatchEvent(new Event('consentChanged'));
    },
    onChange: () => {
      const prefs = CookieConsent.getUserPreferences();
      if (!prefs) return;
      const adapted = adaptV3PreferencesToStorage(prefs);
      if (!isConsentPreferences(adapted)) {
        console.error('[CookieConsent] Invalid preferences from v3', prefs);
        return;
      }
      window._matomoOkay =
        prefs.acceptedCategories?.includes('analytical') ?? false;
      saveConsentToStorage(adapted);
      window.dispatchEvent(new Event('consentChanged'));
    },
  };
}

export default {
  install(app: App, _pluginOptions?: object) {
    const config = {
      ...baseConfig,
      ...createConsentCallbacks(),
    };
    CookieConsent.run(config as Parameters<typeof CookieConsent.run>[0]);
    app.config.globalProperties.$cc = CookieConsent as CookieConsentInstance;
  },
};
